import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { FileImageOutlined, InboxOutlined } from '@ant-design/icons';

import { Flex, Typography, Upload } from 'antd';
import cn from 'classnames';

import { useOfferSlice } from 'entities/Offer';
import { TaskAttachmentRead } from 'shared/api/client/codegen.api';

import styles from './TaskAttachments.module.scss';

interface ITaskAttachmentsProps extends HTMLAttributes<HTMLDivElement> {
	files?: TaskAttachmentRead[];
	isShowUpload?: boolean;
}

export const TaskAttachments: FC<ITaskAttachmentsProps> = ({ className, isShowUpload, files, ...props }) => {
	const { t } = useTranslation();
	const { addAttachments, attachments } = useOfferSlice();
	const materials =
		files ?? attachments.map((tm) => ({ id: tm.uid, file: tm.name, created_at: tm.lastModifiedDate }));
	if (!materials?.length && !isShowUpload) {
		return null;
	}

	const getFileName = (fullName: string) => {
		const nameArr = fullName?.split('/');
		const length = nameArr.length;
		return nameArr[length - 1] || '';
	};

	return (
		<Flex {...props} className={cn(className)} vertical style={{ width: '100%' }} gap={24} justify="space-between">
			<Typography.Title level={5} style={{ margin: 0 }}>{t('Attached materials')}</Typography.Title>
			{ isShowUpload &&
				<Upload.Dragger
					style={{ width: '100%' }}
					beforeUpload={(e) => {
						addAttachments(e);
						return false;
					}}
					multiple={true}
					showUploadList={false}>
					<p className="ant-upload-drag-icon">
						<InboxOutlined />
					</p>
					<p className="ant-upload-text">{t('Click or drag file to this area to upload')}</p>
					<p className="ant-upload-hint">{t('Support for a single or bulk upload')}</p>
				</Upload.Dragger>
			}
			{!!materials?.length &&
				<div className={styles.materials}>
					{materials.map((material) => (
						<Flex gap={8} align='center' className={styles.card} key={material.id}>
							<FileImageOutlined className={styles.icon}/>
							<Typography.Text className={styles.text}>{getFileName(material.file)}</Typography.Text>
						</Flex>
					))}
				</div>
			}
		</Flex>
	);
};
